import { EyeArrowRightOutlineIcon } from './EyeArrowRightOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A682E4C4-6048-4BF7-BBCC-57167CE33687
 * name eye-arrow-right-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/eye-arrow-right-outline.svg
 * tags
 */
export const ViewArrowRightOutlineIcon = EyeArrowRightOutlineIcon;
export default ViewArrowRightOutlineIcon